// Shared editor/PDF contract. A revision reason is never an assessment narrative.
const INTERVENTION_NARRATIVE_FIELDS = Object.freeze([
  { key: 'clientApplicationOverview', snapshotKey: 'client_application_overview', label: 'Client overview' },
  { key: 'trainingEmploymentGoal', snapshotKey: 'training_employment_goal', label: 'Training/employment goal' },
  { key: 'recommendationJustification', snapshotKey: 'recommendation_justification', label: 'Recommendation justification' },
]);
const owns = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);
const text = value => typeof value === 'string' ? value : '';

function hasInterventionAssessmentNarratives(metadata = {}) {
  return INTERVENTION_NARRATIVE_FIELDS.every(({ key }) => owns(metadata, key));
}

function readInterventionAssessmentNarratives(metadata = {}, defaults = {}) {
  return Object.fromEntries(INTERVENTION_NARRATIVE_FIELDS.map(({ key, snapshotKey }) => [
    key, text(owns(metadata, key) ? metadata[key]
      : owns(metadata, snapshotKey) ? metadata[snapshotKey] : defaults[key]),
  ]));
}

function interventionNarrativesFromSnapshot(snapshot = {}) {
  return Object.fromEntries(INTERVENTION_NARRATIVE_FIELDS.map(({ key, snapshotKey }) => [key, text(snapshot?.[snapshotKey])]));
}

function interventionNarrativeSnapshot(metadata = {}, baseline = {}) {
  const values = readInterventionAssessmentNarratives(metadata, interventionNarrativesFromSnapshot(baseline));
  // Keep this shared CommonJS module free of Babel's ESM spread-helper imports.
  const snapshot = Object.fromEntries(INTERVENTION_NARRATIVE_FIELDS.map(({ key, snapshotKey }) => [snapshotKey, values[key]]));
  if (metadata.revision) snapshot.revision_reason = text(metadata.rationale);
  if (hasInterventionAssessmentNarratives(metadata)) snapshot.intervention_narratives_version = 1;
  return snapshot;
}

module.exports = {
  INTERVENTION_NARRATIVE_FIELDS,
  hasInterventionAssessmentNarratives,
  readInterventionAssessmentNarratives,
  interventionNarrativesFromSnapshot,
  interventionNarrativeSnapshot,
};
